import React from 'react';
import './ProductsList.css';

const ProductsList = ({ products, onEditProduct, onDeleteProduct }) => {
    const formatPrice = (price, currency) => {
        if (price === 0) {
            return 'Freebie';
        }
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: currency || 'EUR'
        }).format(price);
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return 'Unknown';
        return new Date(timestamp).toLocaleDateString('de-DE', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    const getProductTypeIcon = (type) => {
        switch (type) {
            case 'digital': return <i className="fas fa-download"></i>;
            case 'course': return <i className="fas fa-graduation-cap"></i>;
            case 'event': return <i className="fas fa-calendar-alt"></i>;
            default: return <i className="fas fa-box"></i>;
        }
    };

    const getProductTypeName = (type) => {
        switch (type) {
            case 'digital': return 'Digital Product';
            case 'course': return 'Online Course';
            case 'event': return 'Live Event';
            default: return 'Product';
        }
    };

    if (!products.length) {
        return null;
    }

    return (
        <div className="salesgod-products-list">
 
            
            <div className="salesgod-products-container">
                {products.map(product => (
                    <div 
                        key={product.id} 
                        className="salesgod-product-card"
                        data-type={product.type}
                        onClick={() => onEditProduct(product.id)}
                    >
                        {/* Left Section - Icon & Main Info */}
                        <div className="salesgod-product-left">
                            <div className="salesgod-product-icon-container">
                                <div className="salesgod-product-icon" data-type={product.type}>
                                    {getProductTypeIcon(product.type)}
                                </div>
                            </div>
                            
                            <div className="salesgod-product-main-info">
                                <div className="salesgod-product-header-row">
                                    <h3 className="salesgod-product-title">{product.title}</h3>
                                    <div className="salesgod-product-actions">
                                        <button 
                                            className="salesgod-action-btn salesgod-edit-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onEditProduct(product.id);
                                            }}
                                            title="Edit Product"
                                        >
                                            <i className="fas fa-edit"></i>
                                        </button>
                                        <button 
                                            className="salesgod-action-btn salesgod-delete-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (onDeleteProduct) {
                                                    onDeleteProduct(product.id);
                                                }
                                            }}
                                            disabled={!onDeleteProduct}
                                            title="Delete Product"
                                        >
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                
                                <div className="salesgod-product-meta-row">
                                    <div className="salesgod-product-meta">
                                        <span className="salesgod-product-type">
                                            {getProductTypeName(product.type)}
                                        </span>
                                        <span className="salesgod-meta-separator">•</span>
                                        <span className="salesgod-product-date">
                                            {formatDate(product.createdAt)}
                                        </span>
                                    </div>
                                </div>
                                
                                <div className="salesgod-product-description">
                                    {product.description.length > 120 
                                        ? `${product.description.substring(0, 120)}...` 
                                        : product.description
                                    }
                                </div>
                                
                                <div className="salesgod-product-bottom-row">
                                    <div className="salesgod-product-status-text">
                                        {product.status}
                                    </div>
                                    <div className="salesgod-product-price-text">
                                        {formatPrice(product.price, product.currency)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductsList;